/* THREE STAR — grain overlay, custom cursor, scroll reveal.
   Lightweight, no dependencies, respects prefers-reduced-motion. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Film grain canvas loop ---- */
  var canvas = document.getElementById('three-star-grain');
  if (canvas && !reduceMotion) {
    var ctx = canvas.getContext('2d');
    var w, h;
    function resize() {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    var frame = 0;
    function drawGrain() {
      frame++;
      if (frame % 2 === 0) { // throttle to ~30fps
        var imageData = ctx.createImageData(w, h);
        var buffer = imageData.data;
        for (var i = 0; i < buffer.length; i += 4) {
          var shade = Math.random() * 255;
          buffer[i] = shade;
          buffer[i + 1] = shade;
          buffer[i + 2] = shade;
          buffer[i + 3] = 18;
        }
        ctx.putImageData(imageData, 0, 0);
      }
      requestAnimationFrame(drawGrain);
    }
    requestAnimationFrame(drawGrain);
  }

  /* ---- Custom cursor (desktop, fine pointer only) ---- */
  var cursor = document.getElementById('three-star-cursor');
  if (cursor && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.body.classList.add('ts-cursor-ready');
    window.addEventListener('mousemove', function (e) {
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    });
    var interactiveSelectors = 'a, button, input, select, .ts-btn, [role="button"]';
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest(interactiveSelectors)) {
        document.body.classList.add('ts-cursor-active');
      }
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest(interactiveSelectors)) {
        document.body.classList.remove('ts-cursor-active');
      }
    });
  } else if (cursor) {
    cursor.remove();
  }

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll('.ts-reveal');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }
})();
